<template>
  <div class="word-viewer_modal" v-show="visible" @click="closeModal">
    <div class="word-viewer_header">{{title}}</div>
    <div class="word-viewer_body">
      <div class="word-viewer_container">
        <div class="word-viewer_text">{{content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    content: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(["editSandtable"]),
  },
  watch: {
    visible(value) {},
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0,
      isShowImage: false,
      innerVisible: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="less" scoped>
.word-viewer_modal {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 10000000000;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.word-viewer_modal * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.word-viewer_header {
  top: 0;
  left: 0;
  z-index: 5500;
  width: 100%;
  height: 20vh;
  text-align: center;
  font-size: 16px;
  line-height: 20vh;
}

.word-viewer_body {
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.word-viewer_container {
  width: 90%;
  height: 90%;
  overflow: auto;
}

.word-viewer_text {
  white-space: pre-wrap;
}
</style>